import { Injectable } from '@angular/core';
import { createFrom, EventService } from '@spartacus/core';
import { filter, map } from 'rxjs/operators';
import { NavigationEvent } from '@spartacus/storefront';
import { FbqGgCartPageEvent } from './fbq-gg-cart-page-event';

@Injectable({
  providedIn: 'root',
})
export class FbqGgCartPageEventBuilder {
  constructor(private eventService: EventService) {
    const fbqGgCartPageEventSource = this.eventService.get(NavigationEvent).pipe(
      filter((navigationEvent) => navigationEvent.semanticRoute === 'cart'),
      map(() =>
        createFrom(FbqGgCartPageEvent, {
          event: 'ViewContent',
        })
      )
    );

    eventService.register(FbqGgCartPageEvent, fbqGgCartPageEventSource);
  }
}
